'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = require('recompose');

var _editor = require('../editor');

var _captionConstants = require('./captionConstants');

require('./Caption.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Styles


var Caption = function (_React$Component) {
    _inherits(Caption, _React$Component);

    function Caption(props) {
        _classCallCheck(this, Caption);

        var _this = _possibleConstructorReturn(this, (Caption.__proto__ || Object.getPrototypeOf(Caption)).call(this, props));

        _this.wrappedSaveCaptionContent = _this.wrappedSaveCaptionContent.bind(_this);
        return _this;
    }

    _createClass(Caption, [{
        key: 'wrappedSaveCaptionContent',
        value: function wrappedSaveCaptionContent(caption, sync) {
            // Don't save if the caption isn't visible.  This helps prevent empty operations from being added to the
            // undo stack
            var _props = this.props,
                captionVisible = _props.captionVisible,
                saveCaptionContent = _props.saveCaptionContent;

            if (!captionVisible) return null;

            saveCaptionContent(caption, sync);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                captionVisible = _props2.captionVisible,
                showDivider = _props2.showDivider,
                element = _props2.element;

            if (!captionVisible) return null;

            return _react2.default.createElement(
                'div',
                { className: 'Caption' },
                showDivider ? _react2.default.createElement('div', { className: 'caption-divider' }) : null,
                _react2.default.createElement(_editor.SimpleTextEditor, _extends({}, this.props, {
                    saveContent: this.wrappedSaveCaptionContent,
                    editorId: element.get('id') + '-CAPTION',
                    editorKey: _captionConstants.CAPTION_EDITOR_KEY }))
            );
        }
    }]);

    return Caption;
}(_react2.default.Component);

Caption.propTypes = {
    element: _propTypes2.default.object.isRequired,
    isEditing: _propTypes2.default.bool,
    isEditable: _propTypes2.default.bool,
    startEditing: _propTypes2.default.func,
    stopEditing: _propTypes2.default.func,
    saveCaptionContent: _propTypes2.default.func,
    onEmptyBackspace: _propTypes2.default.func,
    textContent: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
    captionVisible: _propTypes2.default.bool,
    currentEditorKey: _propTypes2.default.string,
    createNewCard: _propTypes2.default.func,
    showDivider: _propTypes2.default.bool
};

exports.default = (0, _recompose.onlyUpdateForPropTypes)(Caption);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/caption/Caption.js
// module id = 424
// module chunks = 0